// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px"};